import Oidc from 'oidc-client';

import { passportURL } from './config'

const resolveURL = ()=>{
    return passportURL[window.location.host]
}

// define java script client for identity server 4
let config = {
    authority: resolveURL(), // replace with real auth link based on environment
    client_id: "Selfly.CoreApi.UI",
    redirect_uri: `${window.location.origin}/callback.html`, // created callback file to finalize open ID loop
    response_type: "id_token token",
    scope: "openid profile ipa_api3",
    post_logout_redirect_uri: window.location.origin, // get current URL
};

console.log(config)

let mgr = new Oidc.UserManager(config);
mgr.startSilentRenew();

// export user manager
export default mgr;


// WEBPACK FOOTER //
// ./src/auth-config.js